import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-medium text-lg pr-5 mb-1" }
const _hoisted_2 = { class: "inline-flex items-center text-sm text-blue-600 dark:text-blue-400 underline" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "View", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_external_link_icon = _resolveComponent("external-link-icon")!
  const _component_external_link = _resolveComponent("external-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[
      _ctx.done
        ? 'bg-gray-400 bg-opacity-20 dark:bg-gray-800 opacity-80 shadow-inner'
        : 'bg-white dark:bg-gray-800 shadow-md',
    ], "rounded-md py-3 px-5 relative"])
  }, [
    (_ctx.done)
      ? (_openBlock(), _createBlock(_component_CheckIcon, {
          key: 0,
          class: "absolute top-3 right-3 w-6 text-green-600"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.name), 1),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.dateClass, "inline-block text-sm text-white uppercase px-3 rounded font-bold"])
    }, _toDisplayString(_ctx.monthName) + " " + _toDisplayString(_ctx.year), 3),
    (_ctx.href !== '')
      ? (_openBlock(), _createBlock(_component_external_link, {
          key: 1,
          href: _ctx.href,
          class: "float-right"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_external_link_icon, { class: "ml-1" })
            ])
          ]),
          _: 1
        }, 8, ["href"]))
      : _createCommentVNode("", true)
  ], 2))
}